<template>
  <div class="mod-config">
    <div class="top">
      万安迪
    </div>
    <div class="list-div">
      <div>
        <p style="color:#8DCAE6;font-size: 18px;">月份</p>
        <p>{{year+"年"+month+"月"}}</p>
      </div>
      <div style="color:#8DCAE6;font-size: 18px;line-height: 60px;">
        周报推送
      </div>
      <div>
        <p style="color:#8DCAE6;font-size: 18px;">周数</p>
        <p>{{"第"+week+"周"}}</p>
      </div>
    </div>
    <div  @scroll="listScroll($event)" style="height: calc(100% - 104px);overflow-y: scroll;">
      <div class="box" v-for="(item,i) in list">
        <div v-for="(index,y) in item.reportDeviceList">
          <i></i>
          <div class="list-ul">
            <ul>
              <li>
                <p style="color: #8DCAE6;">设备名称</p>
                <p>{{index.deviceName}}</p>
              </li>
              <li>
                <p style="color: #8DCAE6;">唯一编码</p>
                <p>{{index.uniqueCode}}</p>
              </li>
              <li>
                <p style="color: #8DCAE6;">所属点位</p>
                <p>{{index.poiName}}</p>
              </li>
              <li>
                <p style="color: #8DCAE6;">所属企业</p>
                <p>{{item.companyName}}</p>
              </li>
            </ul>
            <div  :id="forID(index.deviceId)" ref="dataInfo" style='width: 45%;height: 100%;float: right;'></div>
          </div>
          <div style="padding: 0 2px;padding-bottom: 20px;">
            <el-table
              :data="index.reportChannelList"
              border
              style="width: 100%"
              stripe>
              <el-table-column
                prop="channelName"
                width="85"
                align="center"
                label="监测因子">
              </el-table-column>
              <el-table-column
                prop="maxValues"
                align="center"
                label="最大值">
              </el-table-column>
              <el-table-column
                prop="minValues"
                align="center"
                label="最小值">
              </el-table-column>
              <el-table-column
                prop="avgValue"
                width="80"
                align="center"
                label="平均值">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
@import '../assets/layui/css/layui.css';
@import '../assets/css/wx_form.css';

/deep/ .el-table__header-wrapper table thead .is-leaf {
  background: #283F91;
  color: #8DCAE6;
}

/deep/ .el-table--enable-row-transition .el-table__body td {
  background-color:#0B132F;
  color: #fff;
}

/deep/ .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #283F91 !important;
}
/deep/ .el-table--striped .el-table__body tr.el-table__row--striped td:hover {
  background: #283F91 !important;
}
/deep/ .el-table td, /deep/ .el-table th.is-leaf {
  border-right: 1px solid #8DCAE6;
  border-bottom: 1px solid #8DCAE6;
}

/deep/ .el-table--border, .el-table--group {
  border: 1px solid #8DCAE6;
}
/deep/ .el-table--border::after, /deep/ .el-table--group::after, /deep/ .el-table::before{
  content:initial;
}
/deep/ .el-table th,/deep/ .el-table tr {
  font-size: 12px !important;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background: #0B132F;
}
</style>

<script>
import {getUUID} from "@/utils";

export default {
  name: "login_wx",
  data() {
    return {
      loginForm: {
        code: '',
      },
      year:'',
      month:'',
      week:'',
      list:[],
      pageIndex:1
      }
  },

  created() {
    this.loginForm.code = this.getUrlCode()

  },
  mounted(){
    this.getDataList();
  },
  methods: {
    //滚动条触发事件
    listScroll($event) {
      var _this = this
      if ((parseInt($event.target.clientHeight) + parseInt($event.target.scrollTop)) === parseInt($event.target.scrollHeight)) {
        _this.pageIndex +=1
        _this.getDataList();
      }
    },

    forID(i) {
      return 'kdEcharts'+i
    },
    getDataList(){
      let loading;
      loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let path = window.location.href.split("?pageNum=1&")[1] //分割url
      this.$http({
        url: this.$http.adornUrl('api/wechat/report?'+path),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
        })
      }).then(({data}) => {
        loading.close();
        if (data && data.code === 200) {
          let listdata = this.list
          let reportVo = data.data.reportVo
          if(reportVo.length>=0){
            reportVo.forEach(item=>{
              listdata.push(item)
            })
          }
          this.year = data.data.year
          this.month = data.data.month
          this.week = data.data.week
          this.list = listdata
        }
        this.myEcharts();
      }).catch(() =>
        this.$message.warning("没有更多数据")
      ); //捕获异常
    },
    myEcharts(){
      this.$nextTick(function(){
        for(var i=0;i<this.list.length;i++){
          var reportDeviceList = this.list[i].reportDeviceList
          for(var j=0; j<reportDeviceList.length;j++){
            // console.log(reportDeviceList[j].deviceId)
            var deviceId = reportDeviceList[j].deviceId;
            const colorList = ['#C3C3C3', '#47A2FD'];
            let myChart = this.$echarts.init(document.getElementById('kdEcharts'+ deviceId));
            let option = {
              title: {
                subtext: '月缺失率',
                subtextStyle: {
                  fontSize: 12,
                  color: '#47A2FD'
                },
                textAlign: 'center',
                left: '38%',
                top: '34%'
              },
              legend: [
                {
                  data:['接受率'],
                  bottom:'12',
                  right:'-4',
                  itemWidth:10,//图例的宽度
                  itemHeight:8,//图例的高度
                  textStyle:{//图例文字的样式
                    color:'#ccc',
                    fontSize:10
                  },
                  selectedMode:false,
                },
                {
                  data:['缺失率'],
                  bottom:'0',
                  right:'-4',
                  itemWidth:10,//图例的宽度
                  itemHeight:8,//图例的高度
                  textStyle:{//图例文字的样式
                    color:'#ccc',
                    fontSize:10
                  },
                  selectedMode:false,
                }
              ],
              tooltip: {
                trigger: 'item',
                textStyle: {
                  color: "#fff",
                }
              },
              color: colorList,
              series: [
                {
                  name: '',
                  type: 'pie',
                  radius: ['52%', '76%'],
                  center: ['40%', '50%'],
                  avoidLabelOverlap: false,
                  hoverOffset: 12,
                  itemStyle: {
                    borderRadius: 10,
                    borderColor: '#0b132f',
                    borderWidth: 2
                  },
                  label: {
                    normal: {
                      show: true,
                      formatter: "{d}%",
                      textStyle: {
                        fontSize: 11,
                        color: "#fff"
                      },
                    },
                  },
                  labelLine: {
                    normal: {
                      smooth: 0.2,
                      length: 8,
                      length2: 8,
                    }
                  },
                  data: [
                    {name: '缺失率', value: reportDeviceList[j].lostRate},
                    {name: '接受率', value: reportDeviceList[j].acceptRate},

                  ],
                }
              ]
            };
            myChart.setOption(option);
            window.addEventListener("resize", function () {
              myChart.resize();
            })
          }
        }
      })
    },
    // 截取url中的code方法 ,this.$route.query.code是获取不到code的，需要截取
    getUrlCode() {
      //http://test.szwandi.cn/iot/?code=093YDkFa1wU6MB0I80Ja1lwq8F3YDkFR&state=#/login_wx
      let url = location.href
      if (url.indexOf("?") !== -1) {
        try {
          let obj = url.split("&")[0].split("=")[1]
          return obj
        } catch (e) {
          this.$message.error("code解析异常");
          console.log("code解析异常！", url)
          return null
        }
      }
      return null
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/pages/wx_form_week.vue